export default {
  //用户列表
  aboutBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/about-jcn/about-banner.vue'));
    }, '/modules/about-jcn/about-banner');
  },
  //企业简介
  aboutStract: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/about-jcn/stract-list.vue'));
    }, '/modules/about-jcn/stract-list');
  },
  //应用客户
  aboutCustomer: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/about-jcn/list.vue'));
    }, '/modules/about-jcn/list');
  },
  //合作伙伴
  aboutPartner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/about-jcn/partner-list.vue'));
    }, '/modules/about-jcn/partner-list');
  }
  // //企业文化
  // aboutCulture: resolve => {
  //   require.ensure([], () => {
  //     resolve(require('@/views/about-jcn/about-culture.vue'));
  //   }, '/modules/about-jcn/about-culture');
  // }
}



// WEBPACK FOOTER //
// ./src/router/modules/about-jcn.js